<template lang="pug">
    .ma-md-4
        v-simple-table.overflow-y-auto(v-if="messages.length > 0" v-bind:style="{ height: height + 'px' }")
            template(v-slot:default)
                thead(style="padding-top: 15px;")
                    tr.volie-background-color-blue
                        th.white--text Datetime
                        th.white--text Organization
                        th.white--text Campaign
                        th.white--text Customer
                        th.white--text Agent
                        th.white--text Direction
                        th.white--text From
                        th.white--text To
                        th.white--text Body
                        th.white--text Status
                        th.white--text # Segments
                        th.white--text Media
                tbody
                    tr(v-for='message in messages' :key='message.message_id')
                        td.no-wrap.sm-width
                            //- router-link(:to="{ name: 'messages_show', params: { message_key: message.message_key } }") {{ message.friendly_short_created_at }}
                            | {{ message.friendly_short_created_at }}
                        td.no-wrap.sm-width
                            v-tooltip(top)
                                template(v-slot:activator='{ on, attrs }')
                                    span(v-bind="attrs" v-on="on" role="text")
                                        | {{ message.organization_name | str_limit(20) }}
                                span
                                    | {{ message.organization_name }}
                        FormattedTableCell.no-wrap.sm-width(
                            :text="message.campaign_name"
                            :tooltip="message.campaign_name"
                            :limit="20"
                        )
                        td.no-wrap.sm-width
                            v-tooltip(top v-if=" message.customer_full_name && message.customer_full_name.length > 0")
                                template(v-slot:activator='{ on, attrs }')
                                    span(v-bind="attrs" v-on="on" role="text")
                                        | {{ message.customer_full_name | str_limit(20) }}
                                span
                                    | {{ message.customer_full_name }}
                            template(v-else)
                                | ---
                        td.no-wrap.sm-width
                            v-tooltip(top v-if=" message.user_full_name && message.user_full_name.length > 0")
                                template(v-slot:activator='{ on, attrs }')
                                    span(v-bind="attrs" v-on="on" role="text")
                                        | {{ message.user_full_name | str_limit(20) }}
                                span
                                    | {{ message.user_full_name }}
                            template(v-else)
                                | ---

                        td.no-wrap.xs-width {{ message.direction | titleize }}
                        td.no-wrap.xs-width {{ message.from_number | tel }}
                        td.no-wrap.xs-width {{ message.to_number | tel }}
                        td.no-wrap.xs-width
                            v-tooltip(top v-if=" message.body && message.body.length > 0")
                                template(v-slot:activator='{ on, attrs }')
                                    span(v-bind="attrs" v-on="on" role="text")
                                        v-icon mdi-eye
                                span
                                    | {{ message.body }}
                            template(v-else)
                                | ---
                        td.no-wrap.xs-width
                            strong.text-uppercase(v-bind:class="[messageEventStatusClass(message)]") {{ (message.last_message_event_status || 'delivered') | titleize }}
                        td.no-wrap.xs-width {{ message.segment_count }}
                        td.no-wrap.xs-width
                            template(v-if="message.media_count > 0")
                                v-icon mdi-image-area
                            template(v-else)
                                | ---
                                
                    ShowMoreRow(
                        :handle-show-more="handleShowMore"
                        :loading="isShowMoreLoading"
                        :show-more="showMoreable"
                    )
</template>

<script lang="ts">
import Vue from 'vue';

// Components
    import ShowMoreRow from '@/components/shared/show_more_row_new.vue';
    import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";
    import FormattedTableCell from "@/components/shared/formatted_table_cell.vue";

export default Vue.extend({
    data() {
        return {

        }
    },
    methods: {
        messageEventStatusClass(msg) {
            let className = "";
            switch(msg?.last_message_event_status) {
            case "accepted":
                className = "green--text";
                break;
            case "delivered":
                className = "green--text";
                break;
            case "failed":
                className = "error--text";
                break;
            case "queued":
                className = "info--text";
                break;
            case "read":
                className = "green--text";
                break;
            case "received":
                className = "green--text";
                break;
            case "receiving":
                className = "warning--text";
                break;
            case "sending":
                className = "warning--text";
                break;
            case "sent":
                className = "green--text";
                break;
            case "undelivered":
                className = "error--text";
                break;
            case "unknown":
                className = "info--text";
                break;
            default: // if not present, assume delivered since historically we do not have this data
                className = "green--text";
                break;
            }

            return className;
        },
    },
    computed: {

    },
    components: {
        FormattedTableCell,
        ShowMoreRow,
        StrLimitTooltipText,
    },
    props: {
        messages: Array,
        height: Number,
        isLoading: Boolean,
        isShowMoreLoading: Boolean,
        limit: Number,
        handleShowMore: Function,
        showMoreable: Boolean,
    },
    watch: {

    },
    created() {
    },
    destroyed() {
    },
    mounted() {
    },
})
</script>

<style lang="scss" scoped>

</style>